import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6 md:p-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-600 mb-8 text-center">
          Last updated: June 29, 2025
        </p>

        <section className="mb-8">
          <p className="text-gray-700 leading-relaxed">
            This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Interpretation and Definitions
          </h2>
          <h3 className="text-xl font-medium text-gray-800 mb-2">Interpretation</h3>
          <p className="text-gray-700 leading-relaxed">
            The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>
          <h3 className="text-xl font-medium text-gray-800 mt-6 mb-2">Definitions</h3>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2">
            <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party...</li>
            <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Marketing Birbal, A-295, Vaishali Nagar, Jaipur, Rajasthan.</li>
            <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device...</li>
            <li><strong>Country</strong> refers to: Rajasthan, India</li>
            <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
            <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>Service</strong> refers to the Website.</li>
            <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company...</li>
            <li><strong>Usage Data</strong> refers to data collected automatically...</li>
            <li><strong>Website</strong> refers to marketingbirbal.com, accessible from <a href="https://www.marketingbirbal.com/#home" className="text-blue-600 hover:underline">https://www.marketingbirbal.com/#home</a></li>
            <li><strong>You</strong> means the individual accessing or using the Service...</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Collecting and Using Your Personal Data
          </h2>
          <h3 className="text-xl font-medium text-gray-800 mb-2">Types of Data Collected</h3>
          <h4 className="text-lg font-medium text-gray-800 mb-2">Personal Data</h4>
          <p className="text-gray-700 leading-relaxed">
            While using Our Service, We may ask You to provide Us with certain personally identifiable information...
          </p>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2 mt-2">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>
          <h4 className="text-lg font-medium text-gray-800 mt-6 mb-2">Usage Data</h4>
          <p className="text-gray-700 leading-relaxed">
            Usage Data is collected automatically when using the Service...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Tracking Technologies and Cookies
          </h2>
          <p className="text-gray-700 leading-relaxed">
            We use Cookies and similar tracking technologies to track the activity on Our Service...
          </p>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2 mt-2">
            <li><strong>Cookies or Browser Cookies:</strong> A cookie is a small file placed on Your Device...</li>
            <li><strong>Web Beacons:</strong> Certain sections of our Service and our emails may contain...</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            We use both Session and Persistent Cookies for the purposes set out below:
          </p>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2 mt-2">
            <li><strong>Necessary / Essential Cookies:</strong> Type: Session Cookies...</li>
            <li><strong>Cookies Policy / Notice Acceptance Cookies:</strong> Type: Persistent Cookies...</li>
            <li><strong>Functionality Cookies:</strong> Type: Persistent Cookies...</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Use of Your Personal Data
          </h2>
          <p className="text-gray-700 leading-relaxed">
            The Company may use Personal Data for the following purposes:
          </p>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2 mt-2">
            <li>To provide and maintain our Service...</li>
            <li>To manage Your Account...</li>
            <li>For the performance of a contract...</li>
            <li>To contact You...</li>
            <li>To provide You with news, special offers...</li>
            <li>To manage Your requests...</li>
            <li>For business transfers...</li>
            <li>For other purposes...</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Retention of Your Personal Data
          </h2>
          <p className="text-gray-700 leading-relaxed">
            The Company will retain Your Personal Data only for as long as is necessary...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Transfer of Your Personal Data
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Your information, including Personal Data, is processed at the Company's operating offices...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Delete Your Personal Data
          </h2>
          <p className="text-gray-700 leading-relaxed">
            You have the right to delete or request that We assist in deleting the Personal Data...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Disclosure of Your Personal Data
          </h2>
          <h3 className="text-xl font-medium text-gray-800 mb-2">Business Transactions</h3>
          <p className="text-gray-700 leading-relaxed">
            If the Company is involved in a merger, acquisition or asset sale...
          </p>
          <h3 className="text-xl font-medium text-gray-800 mt-6 mb-2">Law Enforcement</h3>
          <p className="text-gray-700 leading-relaxed">
            Under certain circumstances, the Company may be required to disclose...
          </p>
          <h3 className="text-xl font-medium text-gray-800 mt-6 mb-2">Other Legal Requirements</h3>
          <p className="text-gray-700 leading-relaxed">
            The Company may disclose Your Personal Data in the good faith belief...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Security of Your Personal Data
          </h2>
          <p className="text-gray-700 leading-relaxed">
            The security of Your Personal Data is important to Us, but remember...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Children's Privacy
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Our Service does not address anyone under the age of 13...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Links to Other Websites
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Our Service may contain links to other websites that are not operated by Us...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Changes to this Privacy Policy
          </h2>
          <p className="text-gray-700 leading-relaxed">
            We may update Our Privacy Policy from time to time...
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Contact Us
          </h2>
          <p className="text-gray-700 leading-relaxed">
            If you have any questions about this Privacy Policy, You can contact us:
          </p>
          <ul className="list-disc pl-6 text-gray-700 leading-relaxed space-y-2 mt-2">
            <li>By email: <a href="mailto:connect@marketingbirbal.com" className="text-blue-600 hover:underline">connect@marketingbirbal.com</a></li>
            <li>By phone number: <a href="tel:9211560084" className="text-blue-600 hover:underline">9211560084</a></li>
          </ul>
        </section>

        
      </div>
    </div>
  );
};

export default PrivacyPolicy;